import React from "react";
import styled from "styled-components";
import { Icon } from "react-fa";

const ColumnIcon = styled(Icon)`
  padding-bottom: 1rem;
  margin-bottom: 1px;
`;
const StyledHR = styled.hr`
  display: block;
  width: 90%;
  height: 1px;
  margin: 0 auto 1em;
  border-radius: 50%;
  background-image: linear-gradient(
    to right,
    transparent,
    #c93e4e,
    transparent
  );
`;

const FlexColumn = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: flex-start;
`;

const InfoColumns = () => (
  <div className="section is-medium">
    <div className="container is-fluid">
      <div className="columns is-centered">
        {columnContent.map(column => (
          <ColumnContent key={column.title} {...column} />
        ))}
      </div>
    </div>
  </div>
);

const ColumnContent = (props, index) => (
  <div
    className={`column is-${props.size} is-offset-${props.offset}`}
    key={"column-" + index}
  >
    <FlexColumn>
      <ColumnIcon
        name={props.iconName}
        className={`column-icon has-text-${props.iconColor}`}
        size={props.iconSize}
      />
      <h2 className="subtitle">{props.title}</h2>
      <StyledHR />
      <p>{props.content}</p>
    </FlexColumn>
  </div>
);

const columnContent = [
  {
    title: "50 Years of Experience",
    iconSize: "3x",
    iconName: "group",
    iconColor: "brand",
    size: "2",
    content:
      "Since 1964, we've been in the business of creating glass-to-metal hermetic seals and precision-machined parts."
  },
  {
    title: "CNC Machining & Glass Sealing",
    iconSize: "3x",
    iconName: "wrench",
    iconColor: "brand",
    size: "2",
    offset: "1",
    content:
      "Our brigade of lightning-fast workhorse machines ensure that extreme precision and swift momentum are never compromised."
  },
  {
    title: "Space Travel & Aerospace",
    iconSize: "3x",
    iconName: "rocket",
    iconColor: "brand",
    size: "2",
    offset: "1",
    content:
      "Our team has 1,123 years of combined experience manufacturing parts for space travel and aerospace. We've been on most rocket launches in the U.S. since NASA's Gemini II."
  },
  {
    title: "Risk Mitigation",
    iconSize: "3x",
    iconName: "lock",
    iconColor: "brand",
    size: "2",
    offset: "1",
    content:
      "Accratronics keeps every step of the manufacturing process in-house, allowing our customers to focus on their projects, instead of vendor logistics."
  }
];

export default InfoColumns;



// WEBPACK FOOTER //
// ./src/pages/Home/components/InfoColumns.js